import { useEffect, useRef, type ChangeEvent, type MouseEvent } from 'react'
import { useOnboardingAnalytics } from './useOnboardingAnalytics'
import type { OnboardingScenarioProps } from './types'
import { useBreakUpIntroduction } from './useBreakUpIntroduction'

export function useBreakUpOnboarding({ payload, onChange: change, onComplete, submitting }: OnboardingScenarioProps) {
  const step = payload.step ?? 0
  useOnboardingAnalytics('no_quiz', step === 0 ? 1 : step === 1 ? 2 : 3)
  const screenRef = useRef<HTMLElement>(null)
  useEffect(() => { screenRef.current?.focus() }, [step])
  const introduction = useBreakUpIntroduction({ payload, onChange: change })
  const { name, communicationStyle } = introduction
  const recency = payload.custom?.recency
  const tags = payload.tags ?? []
  const introductionComplete = Boolean(name.trim())
  const situationComplete = Boolean(tags.length && recency)
  const canContinue = step === 0 ? introductionComplete : introductionComplete && situationComplete

  const changeRecency = (event: ChangeEvent<HTMLInputElement>) => change({ ...payload, custom: { ...payload.custom, recency: event.target.value } })
  const toggleSituation = (event: MouseEvent<HTMLButtonElement>) => {
    const tag = event.currentTarget.value
    change({ ...payload, tags: tags.includes(tag) ? tags.filter((value) => value !== tag) : [...tags, tag] })
  }
  const goBack = () => { if (!submitting && step > 0) change({ ...payload, step: step - 1 }) }
  const goNext = () => {
    if (submitting || !canContinue) return
    if (step < 2) change({ ...payload, step: step + 1 })
    else onComplete({ ...payload, communicationStyle, displayName: name.trim(), custom: { ...payload.custom, name: name.trim() } })
  }
  return { ...introduction, step, screenRef, tags, recency, canContinue, changeRecency, toggleSituation, goBack, goNext }
}
